import classNames from 'classnames';
import { isFunction } from 'lodash/fp';
import type * as React from 'react';
import type { MouseEventHandler } from 'react';
import Button from '../Button';
import LinkButton from '../LinkButton';
import styles from './style.m.less';

const COLOR_STYLES = {
    RED: styles.red,
    TEAL: styles.teal,
    BLUE: styles.blue,
    LIGHT_BLUE: styles.lightBlue,
    YELLOW: styles.yellow,
    PURPLE: styles.purple,
    TRANSPARENT: styles.transparent,
    DEFAULT: styles.defaultColor,
};

type PillBoxColor = keyof typeof COLOR_STYLES;

interface Props {
    value: string | number | React.ReactNode;
    color?: PillBoxColor;
    className?: string;
    onClick?: MouseEventHandler;
    href?: string;
}

export default function PillBox({ value, className, onClick, color = 'DEFAULT', href }: Props) {
    const isButton = isFunction(onClick);

    const allClassNames = classNames(
        { [styles.hasOnClick]: isButton || href },
        COLOR_STYLES[color],
        styles.container,
        className
    );

    if (isButton) {
        return (
            <Button kind="PLAIN" className={allClassNames} onClick={onClick}>
                {value}
            </Button>
        );
    }
    if (href) {
        return (
            <LinkButton kind="PLAIN" className={allClassNames} href={href} openInNewTab>
                {value}
            </LinkButton>
        );
    }
    return <span className={allClassNames}>{value}</span>;
}
